import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Search } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';

@Component({
  selector: 'app-enquiry-report-grid',
  templateUrl: './enquiry-report-grid.component.html',
  styleUrls: ['./enquiry-report-grid.component.css']
})
export class EnquiryReportGridComponent implements OnInit {

  title="Preliminary Enquiry";
  itemsPerPage: number=5;
  currentPage: number=1;
  Complaintlist : any = {};
  data : any = {};
  totalItems : number;
  s: Search;
  isSearch:boolean;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }

   ngOnInit() {
    this.GetAllComplaintPaginations(this.itemsPerPage,this.currentPage)
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) { 
    if (this.isSearch)
    this.onSearch(this.s, itemsPerPage, pageNo);
    else   
    this.GetAllComplaintPaginations(itemsPerPage, pageNo);
  }

  pageChanged(pageNumber:number){ 
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
      else 
    this.GetAllComplaintPaginations(this.itemsPerPage, pageNumber);
  }
  // onSearchs(s: Search, itemsPerPage: number, pageNumber: number) {
  //   throw new Error("Method not implemented.");
  // }

  GetAllComplaintPaginations(itemsPerPage: number, pageNo: number){ 
   debugger;
    this.isSearch = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllComplaintPaginations(itemsPerPage,pageNo);
    this.data.subscribe(
         (response: any) => {
          this.Complaintlist= response.ComplaintDetailsModel;    
          this.totalItems= response.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;           
       
          document.getElementById('loader-spinner').style.display = "none";
         },    
         (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        }
      );    
  }



  //delete
  // delete(Comp_id){
  //   swal({
  //        title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
  //     }).then((result) => {
  //       if (result.value) {
  //       this.data = this.userService.DeleteComplaint(Comp_id);
  //       this.data.subscribe(
  //        (response: any) => {
  //            this.GetAllComplaintPaginations(this.itemsPerPage,this.currentPage);          
  //        },(error) => {
  //         document.getElementById('loader-spinner').style.display = "none";
  //         if (error.status == 401|| error.status == 500) {
  //           this.errorHandler.handleError(error);
  //         }
  //         else if (error.status == 400) {
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       }       
  //     ); 
  //   } 
  //   })
  //   }

    //search

    onSearch(s, itemsPerPage: number, pageNo: number) {   
      this.isSearch = true;
      let searchText = this.s.SearchText;
      let searchCriteria = this.s.SearchCriteria;
      if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
        swal("Warning!", "Please enter the search criteria and search text.", "warning");
      else {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.SearchComplaints(searchCriteria, searchText, itemsPerPage, pageNo)
          .subscribe(
            (data: any) => {
              if(data.ComplaintDetailsModel.length!=0){              
               this.Complaintlist= data.ComplaintDetailsModel;   
              this.totalItems = data.TotalItemsCount;
              this.currentPage = pageNo;
              document.getElementById('loader-spinner').style.display = "none";
            }
            else
            {
            document.getElementById('loader-spinner').style.display = "none";         
            }
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });
      }
    }
  
    delete(PrEnq_Id){
      swal({
           title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
          this.data = this.userService.DeleteEnqPr(PrEnq_Id);
          this.data.subscribe(
           (response: any) => {
              //  this.GetComplaintDetails(this.itemsPerPage,this.currentPage);          
           },(error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          }       
        ); 
      } 
      })
      }
  
  }


// WEBPACK FOOTER //
// ./src/app/enquiry-reports/enquiry-report/enquiry-report-grid/enquiry-report-grid.component.ts